module.exports = __webpack_public_path__ + "img/trial1-1.5a74c7d1.png";